<template>
	<div class="markets-container">
		<div class="content-container">
			<BreadCrumb :routerLinks="routerLinks" currentTitle="立即购买"></BreadCrumb>
			<div class="orderInfo-container">
				<div class="orderInfoBox">
					<div class="userInfoItem">
						<div class="itemTitle">
							收货信息
							<div class="addressMenu">
								<div class="addAddress" @click="curAddress = {};dialogReplyViable = true">使用新地址</div>
							</div>
						</div>
						<div class="itemContent">
							<button class="prev-btn" @click="prevImage" v-if="address.length > 3">
								<img src="../assets/MyOrder/iconH.png">
							</button>
							<div class="addressList" ref="thumbnailContainer">
								<div class="addressItem" :class="selAddressIndex == index ? 'active' : 'normal'"
									v-for="(item,index) in address" :key="index" @click="selAddressIndex = index">
									<div class="province ellipsis-1">{{item.sheng}} {{item.shi}} {{item.qu}}</div>
									<div class="address ellipsis-1">{{item.address}}</div>
									<div class="namePhone ellipsis-1">{{item.name}} {{item.phone}}</div>
									<div class="editMenu">
										<img class="editIcon" src="../assets/Personal/iconC.png"
											@click.stop="curAddress = item;dialogAddressViable = true" />
										<img class="editIcon" src="../assets/Personal/iconB.png"
											@click.stop="delAddress(item)" />
									</div>
								</div>
							</div>
							<button class="next-btn" @click="nextImage" v-if="address.length > 3">
								<img src="../assets/MyOrder/iconI.png">
							</button>
							<!-- <div class="addressList">
								<div class="addressItem" :class="selAddressIndex == index ? 'active' : 'normal'"
									v-for="(item,index) in address" :key="index" @click="selAddressIndex = index">
									<div class="province ellipsis-1">{{item.sheng}} {{item.shi}} {{item.qu}}</div>
									<div class="address ellipsis-1">{{item.address}}</div>
									<div class="namePhone ellipsis-1">{{item.name}} {{item.phone}}</div>
									<div class="editMenu">
										<img class="editIcon" src="../assets/Personal/iconC.png"
											@click.stop="curAddress = item;dialogReplyViable = true" />
										<img class="editIcon" src="../assets/Personal/iconB.png"
											@click.stop="delAddress(item)" />
									</div>
								</div>
							</div> -->
						</div>
					</div>
					<div class="confirmOrderInfo">
						<div class="title">
							确认订单信息
						</div>
						<div class="goodsInfoBox">
							<img class="goodsImg" :src="details.img" />
							<div class="goodsInfo">
								<div class="goodsName">{{details.title}}</div>
								<div class="goodsDesc ellipsis-2">
									{{details.content}}
								</div>
								<div class="goodsPrice ellipsis-2">
									<span class="unit">¥</span>
									{{details.original_price}}
								</div>
							</div>
						</div>
						<div class="tips">
							<div class="tipsTitle">温馨提示</div>
							<div class="tipsContent">平台客服收到您的周边商品定制需求后，会先出具样品图片给您查看，如果不满意，可与客服随时联系。</div>
						</div>
						<div class="subTilte">
							导入图片
						</div>
						<div class="imgList">
							<div class="imgItem" v-for="(item,index) in imgList" :key="index">
								<img class="imgItemImg" :src="item" />
								<img class="delete" @click="imgList.splice(index, 1)"
									src="../assets/Feedback/delete.png" />
							</div>
							<div class="addImgBox" @click="uploadPhoto" v-if="imgList.length != 6">
								<img class="addImg" src="../assets/Feedback/addImg.png" />
								上传图片
							</div>
						</div>
						<div class="subTilte">
							备注说明
						</div>
						<div class="replyContent">
							<textarea v-model="content" maxlength="500" placeholder="请输入备注说明"></textarea>
							<div class="textNum">
								<span>{{content.length}}</span>/500
							</div>
						</div>
						<div class="subTilte">
							定制数量
						</div>
						<div class="numBox">
							<input type="text" v-model="count" placeholder="请输入定制数量" @input="validateInput" />
						</div>
					</div>
				</div>
				<div class="payInfoBox">
					<div class="title">
						订单信息
					</div>
					<div class="orderPriceBox">
						<div class="itemTitle">订单金额</div>
						<div class="priceBox" style="margin-right: .1rem;">
							<div class="price">
								<span class="unit">¥</span>
								{{orderCost}}
							</div>
						</div>
					</div>
					<div class="orderPriceBox" style="cursor: pointer;" @click="handleCoupon">
						<div class="itemTitle">代金券</div>
						<div class="priceBox">
							<div class="price">
								<span class="unit">¥</span>
								{{couponCost}}
							</div>
							<img class="arrow" src="../assets/BuyNow/iconI.png" />
						</div>
					</div>
					<div class="payWayBox">
						<div class="payItem" @click="payWay = 1">
							<img class="checkIcon" src="../assets/BuyNow/iconC.png" v-if="payWay == 1" />
							<img class="checkIcon" src="../assets/BuyNow/iconF.png" v-else />
							<img class="payIcon" src="../assets/BuyNow/iconE.png" />
							微信支付
						</div>
						<div class="payItem" @click="payWay = 2">
							<img class="checkIcon" src="../assets/BuyNow/iconC.png" v-if="payWay == 2" />
							<img class="checkIcon" src="../assets/BuyNow/iconF.png" v-else />
							<img class="payIcon" src="../assets/BuyNow/iconD.png" />
							支付宝支付
						</div>
					</div>
					<div class="agreementBox">
						<img class="checkIcon" src="../assets/BuyNow/iconA.png" @click="agree = false" v-if="agree" />
						<img class="checkIcon" src="../assets/BuyNow/iconH.png" @click="agree = true" v-else />
						我已阅读并同意 <span class="userAgreement" @click="userBuy = true">《用户购买须知协议》</span>
					</div>
					<div class="costButNow">
						<div class="costBox">
							实付款
							<div class="cost">
								<span class="unit">¥</span>
								{{cost}}
							</div>
						</div>
						<div class="buyNow" @click="marketOrderAdd">立即购买</div>
					</div>
				</div>
			</div>
		</div>
		<AddAddress :show="dialogReplyViable" :data="curAddress" @close="dialogReplyViable = false"
			@update="userAddress" />
		<CouponDialog :show="dialogCouponVisible" @close="handleClose" @update="curCoupon = $event"
			methodName="/Order/zhoubian_coupon" :params="{goods_id:details.id,count:count}" />
		<el-upload ref="upload" name="image" action="https://ht.daiyuart.com/api.php/set/Other/upload_img"
			:show-file-list="false" :limit="6" multiple :on-success="handlePhotoSuccess">
		</el-upload>
		<el-dialog class="reportDialog" :visible.sync="dialogReportVisible" append-to-body @close="handleClose">
			<div slot="title">
				<div class="dislogTitle">
					支付二维码
				</div>
			</div>
			<div class="dislogConent">
				<img :src="payUrl" style="width: 2rem;height: 2rem;" />
			</div>
			<div slot="footer">
				<div class="menuBox">
					<el-button plain size="medium" @click="dialogReportVisible = false">取消</el-button>
				</div>
			</div>
		</el-dialog>
		<UserBuyAgreeDialog :show="userBuy" @close="userBuy = false" />
		<PopToast :imgPtahUrl="require('@/assets/Feedback/sucIcon.png')" :desc="'购买成功！'" :subTitle="'请到个人中心我的订单中查看！'"
			@clickOk="sucPop = false;$router.replace({path:'/personal-center',query: {menuId: 14}})" v-if="sucPop" />
	</div>
</template>

<script>
	import PopToast from '../components/PopToast.vue'
	import AddAddress from '../../src/components/AddAddress.vue'
	import CouponDialog from '../../src/components/CouponDialog.vue'
	import UserBuyAgreeDialog from '../components/UserBuyAgreeDialog.vue'
	import QRCode from 'qrcode';

	export default {
		components: {
			PopToast,
			AddAddress,
			CouponDialog,
			UserBuyAgreeDialog
		},
		data() {
			return {
				userBuy: false,
				dialogCouponVisible: false,
				dialogReportVisible: false,
				dialogReplyViable: false,
				sucPop: false,
				routerLinks: [{
					path: '/surrounding-markets',
					title: '周边市场',
					query: {}
				}, {
					path: '/markets-details',
					title: '详情',
					query: {
						id: this.$route.query.id
					}
				}],
				selAddressIndex: -1,
				curAddress: {},
				curCoupon: {},
				orderId: '',
				timer: null,
				details: {},
				address: [],
				imgList: [],
				payWay: 1,
				payUrl: '',
				agree: true,
				content: '',
				count: '',
			}
		},
		computed: {
			//优惠券金额
			couponCost() {
				let total = 0
				if (this.details.original_price) {
					if (this.count) {
						if (this.curCoupon.id) {
							if (this.curCoupon.v_type == 1) {
								total = this.curCoupon.original_price * 1
							} else {
								total = (1 - this.curCoupon.original_price / 10) * this.details.original_price * this
									.count * 1
							}
						} else {
							total = 0
						}
					} else {
						total = 0
					}
				}
				return total.toFixed(2)
			},
			orderCost() {
				let total = 0
				if (this.details.original_price) {
					if (this.count) {
						total = this.details.original_price * this.count * 1
					} else {
						total = 0
					}
				}
				return total.toFixed(2)
			},
			//实付金额
			cost() {
				let total = 0
				if (this.details.original_price) {
					if (this.count) {
						if (this.curCoupon.id) {
							if (this.curCoupon.v_type == 1) {
								total = this.details.original_price * this.count * 1 - this.curCoupon.original_price * 1 >=
									0 ?
									this.details.original_price * this.count * 1 - this.curCoupon.original_price * 1 : 0
							} else {
								total = this.details.original_price * this.count * 1 - (1 - this.curCoupon
										.original_price / 10) *
									this.details.original_price * this.count * 1
							}
						} else {
							total = this.details.original_price * this.count * 1
						}
					} else {
						total = 0
					}
				}
				return total.toFixed(2)
			},
		},
		mounted() {
			this.userAddress()
			this.activityDetails()
		},
		beforeDestroy() {
			if (this.timer) {
				clearInterval(this.timer);
			}
		},
		methods: {
			prevImage() {
				const prevIndex = (this.selAddressIndex - 1 + this.address.length) % this.address.length;
				this.selAddressIndex = prevIndex;
				this.scrollToImage();
			},
			nextImage() {
				const nextIndex = (this.selAddressIndex + 1) % this.address.length;
				this.selAddressIndex = nextIndex;
				this.scrollToImage();
			},
			scrollToImage() {
				const container = this.$refs.thumbnailContainer;
				const rootFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize);
				const thumbnailWidth = 2.78 * rootFontSize; // 每个缩略图的宽度，包括间隔
				const maxVisibleThumbnails = 3; // 显示的最大缩略图数量
				// 计算当前选中缩略图的偏移量
				const thumbnailOffset = this.selAddressIndex * thumbnailWidth;
				// 计算需要滚动的距离，保持最多显示3个缩略图
				if (thumbnailOffset >= container.scrollLeft + maxVisibleThumbnails * thumbnailWidth) {
					// 向右滚动
					container.scrollLeft = thumbnailOffset - maxVisibleThumbnails * thumbnailWidth + thumbnailWidth;
				} else if (thumbnailOffset < container.scrollLeft) {
					// 向左滚动
					container.scrollLeft = thumbnailOffset;
				}
			},
			validateInput() {
				this.curCoupon = {}
				this.count = this.count.replace(/[^0-9]/g, '').replace(/^0+/, '');
			},
			uploadPhoto() {
				this.$refs.upload.$el.querySelector('input').click();
			},
			handlePhotoSuccess(response) {
				this.imgList.push(response.data)
			},
			handleCoupon() {
				if (!this.count) return this.$message.warning('请输入定制数量')
				this.dialogCouponVisible = true
			},
			handleClose() {
				this.dialogReportVisible = false
				this.dialogCouponVisible = false
				clearInterval(this.timer);
				this.timer = null
			},
			activityDetails() {
				this.$api.post('/Goods/goods_details', {
					goods_id: this.$route.query.id,
				}).then(res => {
					if (res.code == 1) {
						this.details = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			userAddress() {
				this.$api.post('/UserD/user_address', {}).then(res => {
					if (res.code == 1) {
						this.address = res.data
						if (this.address.length) {
							this.selAddressIndex = 0
							this.scrollToImage()
						}
					}
				}).catch(err => {
					console.log(err);
				})
			},
			delAddress(item) {
				this.$confirm('确认删除当前地址吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.post('/UserD/user_address_del', {
						id: item.id
					}).then(res => {
						if (res.code == 1) {
							this.userAddress()
						}
					}).catch(err => {
						console.log(err);
					})
				}).catch(err => {
					console.log(err);
				});
			},
			marketOrderAdd() {
				if (this.address.length == 0) return this.$message.warning('请添加收货信息')
				if (!this.count) return this.$message.warning('请输入定制数量')
				this.$api.post('/Order/order_add', {
					address_id: this.address[this.selAddressIndex].id,
					img: this.imgList.join(','),
					content: this.content,
					id: this.details.id,
					count: this.count,
					coupon_id: this.curCoupon.id,
				}).then(res => {
					if (res.code == 1) {
						this.submitOrder(res.data)
					}
				}).catch(err => {
					console.log(err);
				})
			},
			submitOrder(orderId) {
				this.$api.post('/Tonglian/order_pay', {
					id: orderId,
				}).then(res => {
					if (res.code == 1) {
						this.orderId = orderId
						this.generateQRCode(res.data)
					}
				}).catch(err => {
					console.log(err);
				})
			},
			generateQRCode(text) {
				let that = this
				QRCode.toDataURL(text, function(error, url) {
					that.payUrl = url
					that.dialogReportVisible = true
					that.timer = setInterval(() => {
						that.checkOrder()
					}, 5000)
				});
			},
			checkOrder() {
				this.$api.post('/Notify/check_order', {
					order_id: this.orderId,
					type: 3
				}).then(res => {
					if (res.code == 1) {
						this.dialogReportVisible = false
						clearInterval(this.timer);
						this.timer = null
						this.sucPop = true
					}
				}).catch(err => {
					console.log(err);
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.markets-container {
		background: #FAFAE9;
	}

	.content-container {
		margin: 0 auto;
		display: flex;
		flex-direction: column;
		width: 12rem;
	}

	.orderInfo-container {
		display: flex;
		justify-content: space-between;
		margin-top: .2rem;
		margin-bottom: .8rem;
		width: 12rem;
	}

	.orderInfoBox {
		width: 8.95rem;
	}

	.userInfoItem {
		display: flex;
		flex-direction: column;
		background: #FFFFFF;
		border-radius: .12rem;
		padding: .24rem .24rem;
		width: 8.95rem;

		.itemTitle {
			display: flex;
			align-items: center;
			justify-content: space-between;
			font-weight: 600;
			font-size: .16rem;
			color: #333333;

			.addressMenu {
				display: flex;
				align-items: center;

				.addAddress {
					margin-left: .16rem;
					font-weight: 400;
					font-size: .12rem;
					color: #333333;
					cursor: pointer;
				}
			}
		}

		.itemContent {
			display: flex;
			flex-direction: column;
			position: relative;

			.prev-btn,
			.next-btn {
				position: absolute;
				width: .12rem;
				height: .28rem;
				padding: 0 0;

				img {
					width: .12rem;
					height: .28rem;
				}
			}

			.prev-btn {
				top: calc(50% - .07rem);
				left: 0;
			}

			.next-btn {
				top: calc(50% - .07rem);
				right: 0;
			}

			.phoneEmailSettingBox {
				margin-top: .24rem;
				display: flex;
				align-items: center;

				.phoneEmailSettingItem {
					margin-right: .4rem;
					display: flex;
					align-items: center;

					.phoneEmailSettingItemContent {
						display: flex;
						align-items: center;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;

						span {
							margin-left: .08rem;
							font-weight: 500;
							font-size: .18rem;
							color: #333333;
						}
					}

					.edit {
						margin-left: .08rem;
						width: .34rem;
						height: .2rem;
						background: rgba(226, 147, 88, .2);
						border-radius: .02rem;
						font-weight: 400;
						font-size: .12rem;
						color: #E29358;
						line-height: .2rem;
						text-align: center;
					}
				}
			}

			.register-form {
				.form-group {
					margin-top: .16rem;
					display: flex;
					align-items: center;
					font-weight: 400;
					font-size: .14rem;
					color: #252525;
				}

				.invite-container {
					width: 3rem;
					height: 0.44rem;
					border: .01rem solid #EFD8B8;
					border-radius: 0.04rem;
					padding: 0 0.16rem;
					font-size: 0.14rem;
					color: #333333;
					outline: none;
					display: flex;
					align-items: center;
					justify-content: space-between;
				}

				.invite-input {
					border: none;
					outline: none;
					padding: 0 0;

					font-size: 0.14rem;
					color: #333333;

					&::placeholder {
						color: #999999;
					}
				}

				.save-btn {
					margin-top: .32rem;
					margin-left: 1.2rem;
					width: 1.22rem;
					height: .36rem;
					background: #E29358;
					border-radius: .04rem;
					font-weight: 500;
					font-size: .12rem;
					color: #252525;
					line-height: .36rem;
					text-align: center;
					padding: 0 0;

				}

				// 错误提示样式
				.error-message {
					background: #F56C6C;
					padding: 0.04rem 0.09rem;
					border-radius: 0.02rem;
					font-weight: 400;
					font-size: 0.12rem;
					color: #FFFFFF;
				}
			}

			.addressList {
				margin-top: .24rem;
				width: 100%;
				display: flex;
				white-space: nowrap;
				overflow-x: auto;
				border-left: .14rem solid #FFFFFF;
				border-right: .14rem solid #FFFFFF;

				.active {
					border: .01rem solid #E29358;
				}

				.normal {
					border: .01rem solid #CCCCCC;
				}

				.addressItem {
					flex-shrink: 0;
					margin-right: .16rem;
					width: 2.62rem;
					height: .95rem;
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					padding: .16rem .16rem;
					border-radius: .08rem;
					cursor: pointer;
					position: relative;

					.editMenu {
						position: absolute;
						bottom: .2rem;
						right: .12rem;
						display: flex;
						align-items: center;

						.editIcon {
							margin-left: .08rem;
							width: .12rem;
							height: .12rem;
						}
					}

					.province {
						font-weight: 400;
						font-size: .12rem;
						color: #1C1C1C;
					}

					.address {
						font-weight: 500;
						font-size: .14rem;
						color: #1C1C1C;
					}

					.namePhone {
						font-weight: 400;
						font-size: .12rem;
						color: #1C1C1C;
					}
				}
			}

			.addressList::-webkit-scrollbar {
				width: 0;
				height: 0;
			}

			/* Firefox */
			.addressList {
				scrollbar-width: none;
				/* Firefox 隐藏滚动条 */
			}

			/* IE / Edge 老版本 */
			.addressList {
				-ms-overflow-style: none;
				/* IE11, Edge */
			}
		}
	}

	.confirmOrderInfo {
		margin-top: .16rem;
		display: flex;
		flex-direction: column;
		padding: .24rem .24rem;
		background: #FFFFFF;

		.title {
			font-weight: 600;
			font-size: .16rem;
			color: #333333;
		}

		.subTilte {
			margin-top: .24rem;
			font-weight: 400;
			font-size: .12rem;
			color: #666666;
		}

		.goodsInfoBox {
			margin-top: .24rem;
			display: flex;

			.goodsImg {
				width: 1.1rem;
				height: 1.1rem;
				border-radius: .08rem;
				object-fit: cover;
			}

			.goodsInfo {
				margin-left: .2rem;
				display: flex;
				flex-direction: column;

				.goodsName {
					font-weight: 700;
					font-size: .18rem;
					color: #000000;
				}

				.goodsDesc {
					font-weight: 400;
					font-size: .14rem;
					color: #333333;
				}

				.goodsPrice {
					display: flex;
					align-items: baseline;
					font-weight: 700;
					font-size: .24rem;
					color: #FF0000;

					.unit {
						margin-right: .02rem;
						font-weight: 400;
						font-size: .14rem;
						color: #FF0000;
					}
				}
			}
		}

		.tips {
			margin-top: .24rem;
			display: flex;
			flex-direction: column;
			width: 8.47rem;
			height: .82rem;
			padding: .16rem .16rem;
			background: rgba(250, 239, 221, .5);
			border-radius: .06rem;

			.tipsTitle {
				font-weight: 700;
				font-size: .14rem;
				color: #333333;
			}

			.tipsContent {
				margin-top: .06rem;
				font-weight: 400;
				font-size: .14rem;
				color: #333333;
			}
		}

		.imgList {
			margin-top: .12rem;
			display: flex;
			flex-wrap: wrap;

			.imgItem {
				margin-right: .16rem;
				display: flex;
				width: .86rem;
				height: .86rem;
				border-radius: .04rem;
				overflow: hidden;
				position: relative;

				.delete {
					position: absolute;
					top: .05rem;
					right: .05rem;
					width: .14rem;
					height: .14rem;
					cursor: pointer;
				}

				.imgItemImg {
					width: .86rem;
					height: .86rem;
					object-fit: cover;
				}
			}

			.addImgBox {
				width: .86rem;
				height: .86rem;
				border-radius: .04rem;
				background: #FFFFFF;
				border: 1px solid #EFD8B8;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				font-weight: 400;
				font-size: .12rem;
				color: #999999;
				cursor: pointer;
				line-height: .18rem;

				.addImg {
					margin-bottom: .08rem;
					width: .27rem;
					height: .23rem;
				}
			}
		}

		.replyContent {
			margin-top: .12rem;
			width: 8.47rem;
			height: 1.6rem;
			background: #FFFFFF;
			border-radius: .04rem;
			border: .01rem solid #EFD8B8;
			position: relative;

			.textNum {
				position: absolute;
				right: .12rem;
				bottom: .12rem;
				display: flex;
				align-items: center;
				font-weight: 400;
				font-size: .14rem;
				color: #999999;
				line-height: .2rem;

				span {
					color: #252525;
				}
			}

			textarea {
				width: 100%;
				height: 100%;
				border: none;
				padding: .12rem .12rem;
				font-weight: 400;
				font-size: .14rem;
			}
		}

		.numBox {
			margin-top: .12rem;
			width: 2.05rem;
			height: .52rem;
			background: #FFFFFF;
			border-radius: .04rem;
			padding: 0 .12rem;
			border: .01rem solid #EFD8B8;

			input {
				font-weight: 400;
				font-size: .14rem;
				padding: 0 0;
				border: none;
				line-height: .5rem;
			}
		}
	}

	.payInfoBox {
		display: flex;
		align-self: flex-start;
		flex-direction: column;
		width: 2.88rem;
		background: #FFFFFF;
		padding: .24rem .24rem;
		box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
		border-radius: .12rem;

		.title {
			margin-bottom: .06rem;
			font-weight: 600;
			font-size: .16rem;
			color: #333333;
			line-height: .22rem;
		}

		.orderPriceBox {
			margin-top: .1rem;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.itemTitle {
				font-weight: 400;
				font-size: .14rem;
				color: #333333;
			}

			.priceBox {
				display: flex;
				align-items: center;

				.price {
					display: flex;
					align-items: baseline;
					font-weight: 700;
					font-size: .2rem;
					color: #FF0100;

					.unit {
						font-weight: 400;
						font-size: .14rem;
					}
				}


				.arrow {
					margin-left: .04rem;
					width: .06rem;
					height: .1rem;
				}
			}
		}

		.payWayBox {
			margin-top: .24rem;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			width: 2.4rem;
			height: .96rem;
			background: #FFFFFF;
			border-radius: .08rem;
			border: .01rem solid #EFD8B8;
			padding: .2rem .16rem;

			.payItem {
				display: flex;
				align-items: center;
				font-weight: 500;
				font-size: .14rem;
				color: #333333;
				line-height: .2rem;
				cursor: pointer;

				.checkIcon {
					margin-right: .16rem;
					width: .14rem;
					height: .14rem;
				}

				.payIcon {
					margin-right: .06rem;
					width: .16rem;
					height: .16rem;
				}
			}
		}

		.agreementBox {
			margin-top: .12rem;
			display: flex;
			align-items: center;
			font-size: .12rem;

			.checkIcon {
				margin-right: .06rem;
				width: .14rem;
				height: .14rem;
				cursor: pointer;
			}

			.userAgreement {
				color: #E29358;
				cursor: pointer;
			}
		}

		.costButNow {
			margin-top: .4rem;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.costBox {
				display: flex;
				flex-direction: column;
				font-weight: 400;
				font-size: .12rem;
				color: #333333;

				.cost {
					display: flex;
					align-items: baseline;
					font-weight: 700;
					font-size: .24rem;
					color: #FF0000;

					.unit {
						font-weight: 400;
						font-size: .14rem;
					}
				}
			}

			.buyNow {
				width: 1rem;
				height: .48rem;
				background: #E29358;
				border-radius: .06rem;
				font-weight: 500;
				font-size: .16rem;
				color: #252525;
				line-height: .48rem;
				text-align: center;
				cursor: pointer;
			}
		}
	}

	.reportDialog {

		::v-deep .el-dialog {
			width: 3rem;
			border-radius: .12rem;

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__body {
				padding: 0 .24rem;
				display: flex;
				flex-direction: column;
				align-items: center;
			}

			&__footer {
				padding: .08rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.submit {
						margin: .32rem auto 0;
						width: 1.3rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						text-align: center;
						line-height: .36rem;
						border: none;
						cursor: pointer;
					}
				}
			}
		}
	}
</style>